module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('index-list', {
    attrs: {
      "selectionData": _vm.nowData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ba49d72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/indexlist.vue
// module id = 196
// module chunks = 0